import { FileItem } from "@/repositories/fileRepository";

export const isImageFile = (file: FileItem): boolean => {
  return file.type.startsWith("image");
};
